import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "CSS classes don't work the way you think they work",
  "description": "",
  "published": "2016-10-21T00:00:00.000Z",
  "redirect_from": ["/blog/css-classes-dont-work-way-think-work/swizec/7142"],
  "categories": "Front End, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{}}>{`<p class="blue green red">This is some text</p>
`}</code></pre>
    <p>{`Which color is this text going to be?`}</p>
    <p>{`No cheating, give it a think ??`}</p>
    <p>{`.`}</p>
    <p>{`.`}</p>
    <p>{`.`}</p>
    <p>{`.`}</p>
    <p>{`Blue. The answer is blue. ?`}</p>
    <p>{`Look. I’m not lying. It’s really blue.`}</p>
    <iframe {...{
      "src": "http://codepen.io/swizec/embed/preview/BLvpER/",
      "style": {
        "width": "100%",
        "height": "300px"
      }
    }}></iframe>
    <p>{`You can use any permutation of `}<inlineCode parentName="p">{`blue green red`}</inlineCode>{` – the text is still blue. Try it! Edit the codepen. Play around :)`}</p>
    <p>{`Did you find the pattern?`}</p>
    <p>{`CSS classes apply in the order in which they are defined, not the order in which they are invoked. This is `}<em parentName="p">{`not`}</em>{` intuitive.`}</p>
    <p>{`Look: if you switch around the CSS rules, the text becomes red.`}</p>
    <iframe {...{
      "src": "http://codepen.io/swizec/embed/preview/EgGWNY/",
      "style": {
        "width": "100%",
        "height": "300px"
      }
    }}></iframe>
    <p>{`Same HTML, same CSS classes, different order of definitions. Try it; change the code.`}</p>
    <p>{`Maybe this is obvious to everyone but me, but I spent an embarrassing amount of time yesterday and today debugging some React components. It hits you when common components have default styling, and you want to override it in a specific instance.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const P = ({ className, children }) => (
    <p class="{\`italic" blue="" \${classname}\`}="">{children}</p>
); // default P

// ...

const Error = ({ errorText }) => (
    <p class="red">Red error!</p>
); // doesn't become red
`}</code></pre>
    <p>{`The generic `}<inlineCode parentName="p">{`P`}</inlineCode>{` component returns a `}<inlineCode parentName="p">{`<p>`}</inlineCode>{` element with an `}<inlineCode parentName="p">{`italic`}</inlineCode>{` and a `}<inlineCode parentName="p">{`blue`}</inlineCode>{` class. You can expect text to be italic and blue by default.`}</p>
    <p>{`Please don’t do that in real life. This is just an example.`}</p>
    <p>{`It takes a `}<inlineCode parentName="p">{`className`}</inlineCode>{` prop so you can extend classes used.`}</p>
    <p>{`But when you use the `}<inlineCode parentName="p">{`Error`}</inlineCode>{` component, which produces `}<inlineCode parentName="p">{`<p class="italic blue red">Red error!</p>`}</inlineCode>{`, it’s not red. It’s blue because your CSS defines `}<inlineCode parentName="p">{`.red`}</inlineCode>{` first and `}<inlineCode parentName="p">{`.blue`}</inlineCode>{` second.`}</p>
    <p>{`?`}</p>
    <p>{`There is no workaround. This is expected behavior. The `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/selectors/#specificity"
      }}>{`relevant part`}</a>{` of W3C spec makes no mention of HTML attribute ordering.`}</p>
    <p>{`How did I go 15 years without ever noticing? ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      